import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
export default function PurchaseBillEntryForm({ onClose, editData = null, onSuccess = null }) {

    const [vendors, setVendors] = useState([]);
    const [trims, setTrims] = useState([]);
    const [formData, setFormData] = useState({
        purchase_no: "",
        date: new Date().toISOString().split("T")[0],
        invoice_no: "",
        invoice_date: "",
        vendor_id: "",
        phone: "",
        address: "",
        raw_material_id: "",
        fabric_id: "",
        unit: "",
        quantity: "",
        rate: "",
        amount: "",
    });

    // Load vendors and trims
    useEffect(() => {
        axios.get("/master/vendors").then((res) => setVendors(res.data));
        axios.get("/master/raw_material_stocks").then((res) => setTrims(res.data));
    }, []);

    // If edit mode, prefill data
    useEffect(() => {
        if (editData) {
            setFormData({
                purchase_no: editData.purchase_no || "",
                date: editData.date || new Date().toISOString().split("T")[0],
                invoice_no: editData.invoice_no || "",
                invoice_date: editData.invoice_date || "",
                vendor_id: editData.vendor_id || "",
                phone: editData.phone || "",
                address: editData.address || "",
                raw_material_id: editData.raw_material_id || "",
                fabric_id: editData.fabric_id || "",
                unit: editData.unit || "",
                quantity: editData.quantity || "",
                rate: editData.rate || "",
                amount: editData.amount || "",
            });
        }
    }, [editData]);

    // Auto-fill phone/address on vendor selection
    useEffect(() => {
        if (formData.vendor_id) {
            const selected = vendors.find(v => v.vendor_id === parseInt(formData.vendor_id));
            if (selected) {
                setFormData(prev => ({
                    ...prev,
                    phone: selected.phone_no,
                    address: selected.address,
                }));
            }
        }
    }, [formData.vendor_id, vendors]);

    // Auto-fill unit on trims selection
    useEffect(() => {
        if (formData.raw_material_id) {
            const selected = trims.find(t => t.raw_material_id === parseInt(formData.raw_material_id));
            if (selected) {
                setFormData(prev => ({
                    ...prev,
                    unit: selected.unit,
                }));
            }
        }
    }, [formData.raw_material_id, trims]);

    // Calculate amount
    useEffect(() => {
        const qty = parseFloat(formData.quantity || 0);
        const rate = parseFloat(formData.rate || 0);
        setFormData(prev => ({ ...prev, amount: (qty * rate).toFixed(2) }));
    }, [formData.quantity, formData.rate]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        try {
            if (editData) {
                await axios.put(`/purchase_bill/purchases/${editData.purchase_bill_id}`, formData);
                Swal.fire({ icon: "success", text: "Purchase Bill Updated", timer: 2000, showConfirmButton: false });
            } else {
                await axios.post("/purchase_bill/purchases", formData);
                Swal.fire({ icon: "success", text: "Purchase Bill Saved", timer: 2000, showConfirmButton: false });
            }
            if (onClose) onClose();
            if (typeof onSuccess === "function") onSuccess(); // ✅ Call parent success callback
        } catch (err) {
            console.log("Error saving purchase: ", err);
            Swal.fire({ icon: "error", text: "Error saving purchase", timer: 2000, showConfirmButton: false });
        }
    };

    return (
        <div className="max-w-4xl mx-auto p-6 bg-white">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">
                    {editData ? "Edit Purchase Bill" : "Purchase Bill Entry"}
                </h2>
                <button onClick={onClose} className="text-red-600 font-semibold text-sm">Close ✖</button>
            </div>

            {/* Row 1 */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                <input name="purchase_no" value={formData.purchase_no} onChange={handleChange} placeholder="Purchase No" className="border p-2" />
                <input name="date" type="date" value={formData.date} onChange={handleChange} className="border p-2" />
                <input name="invoice_no" value={formData.invoice_no} onChange={handleChange} placeholder="Invoice No" className="border p-2" />
                <input name="invoice_date" type="date" value={formData.invoice_date} onChange={handleChange} className="border p-2" />
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                <select name="vendor_id" value={formData.vendor_id} onChange={handleChange} className="border p-2">
                    <option value="">Select Vendor</option>
                    {vendors.map(v => (
                        <option key={v.vendor_id} value={v.vendor_id}>{v.vendor_name}</option>
                    ))}
                </select>
                <input name="phone" value={formData.phone} readOnly placeholder="Phone" className="border p-2" />
                <input name="address" value={formData.address} readOnly placeholder="Address" className="border p-2" />
            </div>

            {/* Row 3 */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                <select name="raw_material_id" value={formData.raw_material_id} onChange={handleChange} className="border p-2">
                    <option value="">Select Trims</option>
                    {trims.map(t => (
                        <option key={t.raw_material_id} value={t.raw_material_id}>{t.raw_material_name}</option>
                    ))}
                </select>
                <input name="unit" value={formData.unit} readOnly placeholder="Unit" className="border p-2" />
                <input name="quantity" value={formData.quantity} onChange={handleChange} placeholder="Quantity" className="border p-2" />
                <input name="rate" value={formData.rate} onChange={handleChange} placeholder="Rate" className="border p-2" />
                <input name="amount" value={formData.amount} readOnly placeholder="Amount" className="border p-2" />
            </div>

            <button onClick={handleSubmit} className="bg-blue-600 text-white px-6 py-2 rounded">
                {editData ? "Update Purchase" : "Save Purchase"}
            </button>
        </div>
    );
}
